export default "__VITE_ASSET__DbYuLbvf__"